import { render, staticRenderFns } from "./FarmersInfo.vue?vue&type=template&id=ca0ba850&scoped=true&"
import script from "./FarmersInfo.vue?vue&type=script&lang=js&"
export * from "./FarmersInfo.vue?vue&type=script&lang=js&"
import style0 from "./FarmersInfo.vue?vue&type=style&index=0&id=ca0ba850&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0ba850",
  null
  
)

export default component.exports